import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';

@Component({
  selector: 'app-coachmark-device',
  templateUrl: './coachmark-device.component.html',
  styleUrls: ['./coachmark-device.component.scss']
})
export class CoachmarkDeviceComponent implements AfterViewInit {
  show: boolean;
  constructor(private sessionStateService: SessionStateService) { }

  ngAfterViewInit(): void {
   const showInterval =  setInterval(() => {
      this.show = true;
      clearInterval(showInterval);
    }, 3000);
  }

  getDeviceImg() {
    const lang = this.sessionStateService.getLang();
    switch (lang) {
      case 'ES':
        return '../assets/img/icons/coachmarks-devices-es.svg';
      case 'PT':
        return '../assets/img/icons/coachmarks-devices-pt.svg';
      case 'EN':
        return '../assets/img/icons/coachmarks-devices-en.svg';
      default:
        return '../assets/img/icons/coachmarks-devices-pt.svg';
    }
  }
  gotIt() {
    this.show = false;
    this.sessionStateService.setCoachMarkIndividualState(this.sessionStateService.getCoachMarkIndividualState().set('device', false));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/coachmark-device/coachmark-device.component.ts